// frontend\src\pages\AboutPage\Breadcrumbs.js
import { toast } from "react-toastify";

const Breadcrumbs = ({ currentPage, onNavigate }) => {
  const pathParts = currentPage.split('/').filter(part => part && part !== 'content');
  const breadcrumbs = [];
  
  breadcrumbs.push({
    name: 'Справка',
    path: '/content/about.md',
    isActive: currentPage === '/content/about.md'
  });

  let currentPath = '/content';
  pathParts.forEach((part, index) => {
    currentPath += '/' + part;
    if (part.endsWith('.md')) {
      const name = part.replace('.md', '')
        .replace(/-/g, ' ')
        .replace(/\b\w/g, l => l.toUpperCase());
      breadcrumbs.push({
        name: name,
        path: currentPath,
        isActive: index === pathParts.length - 1
      });
    } else {
      const name = part.replace(/-/g, ' ')
        .replace(/\b\w/g, l => l.toUpperCase());
      breadcrumbs.push({
        name: name,
        path: currentPath + '.md',
        isActive: false
      });
    }
  });

  const handleCrumbClick = (crumb) => {
    try {
      const targetPath = crumb.path.endsWith('.md') 
        ? crumb.path 
        : `${crumb.path}/index.md`;
      onNavigate(targetPath);
    } catch (err) {
      console.error("Breadcrumb navigation error:", err);
      toast.error('Ошибка перехода по ссылке');
    }
  };

  return (
    <nav aria-label="breadcrumb">
      <ol className="breadcrumb mb-0 p-2 rounded d-flex align-items-center" 
          style={{ 
            backgroundColor: 'var(--bg-secondary)',
            minHeight: '48px'
          }}>
        {breadcrumbs.map((crumb, index) => (
          <li 
            key={index} 
            className={`breadcrumb-item ${crumb.isActive ? 'active' : ''} d-flex align-items-center`}
            aria-current={crumb.isActive ? 'page' : undefined}
          >
            {crumb.isActive ? (
              <span 
                className="text-primary fw-bold"
                style={{ 
                  color: 'var(--text-primary)',
                  lineHeight: '1.2'
                }}
              >
                {crumb.name}
              </span>
            ) : (
              <button 
                onClick={() => handleCrumbClick(crumb)}
                className="btn btn-link p-0 text-decoration-none border-0 d-flex align-items-center"
                style={{ 
                  color: 'var(--btn-outline-primary-color)',
                  background: 'none',
                  cursor: 'pointer',
                  lineHeight: '1.2'
                }}
              >
                {crumb.name}
              </button>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;